import React, {useState} from 'react'
import { mobile } from '../Services/Agent'
import "./Header.scss"
import { shareFacebook, shareTwitter, shareWhatsapp, openNegishut } from "../Services/Sharing";

export default function Header() {
    const [open, setOpen] = useState(false)

    const scrollMachine = (name) => {
        let video = document.querySelector(".video-page");
        let info = document.querySelector(".info-page");
        let gallery = document.querySelector(".gallery-sec");
        switch (name) {
            case "story":
                video.scrollIntoView({behavior: "smooth", block: "center", inline: "center"});
                setOpen(!open)
                break;
            case "info":
                    info.scrollIntoView({behavior: "smooth", block: "center", inline: "center"});
                    setOpen(!open)
                    break;
            case "gallery":
                    gallery.scrollIntoView({behavior: "smooth", block: "center", inline: "center"});
                    setOpen(!open)
                    break;
            default:
                return
        }
    }

    return (
        <header className="header">
            <a className="ynet_logo" href="https://www.ynet.co.il/" target="_blank"></a>
            <span>20 שנה לנסיגה מלבנון</span>
                <div className="share_menu_up">
                    <div className="ngishut share" onClick={() => openNegishut("Article Head")}></div>
                    <div className="twitter share" onClick={() => shareTwitter("Article Head")}></div>
                    <div className="facebook share" onClick={() => shareFacebook("Article Head")}></div>
                    <div className="whatsapp share" onClick={() => shareWhatsapp("Article Head")}></div>
                </div>
            <div className="hamburger-wrapper" onClick={() => setOpen(!open)}>
                <div className={`ham-1 ${open && "rotate-down"}`}></div>
                <div className={`ham-2 ${open && "go-right"}`}></div>
                <div className={`ham-3 ${open && "rotate-up"}`}></div>
            </div>
            <div className={`nav_container ${open && "open-nav"}`}>
                    <p className="mi menu_item_1" onClick={() => scrollMachine("story")}>סיפורה של רצועת הביטחון</p>
                    <p className="mi menu_item_2" onClick={() => scrollMachine("info")}>הנסיגה מלבנון במספרים</p>
                    <p className="mi menu_item_3"onClick={() => scrollMachine("gallery")}>כל הכתבות</p>
                    <div className="share_menu">
                        <div className="ngishut share" onClick={() => openNegishut("Side Menu")}></div>
                        <div className="twitter share" onClick={() => shareTwitter("Side Menu")}></div>
                        <div className="facebook share" onClick={() => shareFacebook("Side Menu")}></div>
                        <div className="whatsapp share" onClick={() => shareWhatsapp("Side Menu")}></div>
                    </div>
                    <p className="mi menu_item_5">
                        <a href="https://redmail.ynet.co.il/?utm_source=ynet.co.il&utm_medium=referral&utm_campaign=lebanon20" target="_blank" >
                        <i className="far fa-envelope"></i>
                        כתבו לנו
                        </a>
                    </p>
            </div>
        </header>
    )
}

// https://redmail.ynet.co.il/?utm_source=ynet.co.il&utm_medium=referral&utm_campaign=lebanon20
